const parseJson = (value) => {
   if (!value) return null;
   if (typeof value === "object") return value;

   try {
      return JSON.parse(value);
   } catch {
      return null;
   }
};

export const formatCredentialApplicationType = (applicationType) => {
   switch (applicationType) {
      case "bearerToken":
         return "Bearer Token";
      case "basicAuth":
         return "Basic Auth";
      case "database":
         return "Database";
      case "redis":
         return "Redis";
      default:
         return applicationType?.toUpperCase();
   }
};

const valueMatchesCredential = (value, credentialId) => {
   if (!credentialId || value === null || value === undefined) return false;
   if (value === credentialId) return true;

   if (Array.isArray(value)) {
      return value.some((item) => valueMatchesCredential(item, credentialId));
   }

   if (typeof value !== "object") return false;

   if (value.value === credentialId || value.id === credentialId) return true;

   return Object.entries(value).some(([key, nestedValue]) => {
      if ((key === "credential" || key === "credentials") && valueMatchesCredential(nestedValue, credentialId)) {
         return true;
      }

      return valueMatchesCredential(nestedValue, credentialId);
   });
};

export const flowUsesCredential = (flow, credentialId) => {
   const flowCredentials = Array.isArray(flow?.credentials) ? flow.credentials.map(parseJson).filter(Boolean) : [];
   
   if (flowCredentials.some((credential) => credential?.id === credentialId)) return true;

   const steps = parseJson(flow?.steps);
   if (!steps) return false;

   return valueMatchesCredential(steps?.triggers, credentialId) || steps?.nodes?.some((node) => valueMatchesCredential(node?.data?.flowElement?.data, credentialId));
};

export const getCredentialConnectorUsage = (flows, credentialId, connectors = []) => {
   const connectorsById = new Map(connectors.map((connector) => [connector.id, connector]));
   const usageByConnectorId = new Map();

   flows.forEach((flow) => {
      const steps = parseJson(flow?.steps);
      const nodes = steps?.nodes ?? [];

      nodes.forEach((node) => {
         const nodeData = node?.data;
         const connectorId = nodeData?.componentId;

         if (!connectorId || !nodeData?.configFiles || !valueMatchesCredential(nodeData?.flowElement?.data, credentialId)) return;

         const existingUsage = usageByConnectorId.get(connectorId);
         const connector = connectorsById.get(connectorId) ?? nodeData;

         usageByConnectorId.set(connectorId, {
            ...connector,
            id: connectorId,
            name: connector.name ?? connector.label ?? nodeData.label,
            status: connector.status ?? "Active",
            flows: existingUsage?.flows?.some((existingFlow) => existingFlow.id === flow.id) ? existingUsage.flows : existingUsage ? [...existingUsage.flows, flow] : [flow]
         });
      });
   });

   return Array.from(usageByConnectorId.values());
};
